import {
  createErrorType,
  createFetchType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
  createUpdateType,
} from '../actionHelpers';

// Get Required Documents Response
export const GET_REQUIRED_DOCUMENTS_SCOPE = 'GET_REQUIRED_DOCUMENTS';
export const GET_REQUIRED_DOCUMENTS = createFetchType(
  GET_REQUIRED_DOCUMENTS_SCOPE,
);
export const GET_REQUIRED_DOCUMENTS_SUCCESS = createSuccessType(
  GET_REQUIRED_DOCUMENTS_SCOPE,
);
export const GET_REQUIRED_DOCUMENTS_ERROR = createErrorType(
  GET_REQUIRED_DOCUMENTS_SCOPE,
);
export const GET_REQUIRED_DOCUMENTS_LOADING = createLoadingType(
  GET_REQUIRED_DOCUMENTS_SCOPE,
);

// Get Socure Capture Response
export const GET_SOCURE_CAPTURE_SCOPE = 'GET_SOCURE_CAPTURE';
export const GET_SOCURE_CAPTURE = createFetchType(GET_SOCURE_CAPTURE_SCOPE);
export const GET_SOCURE_CAPTURE_SUCCESS = createSuccessType(
  GET_SOCURE_CAPTURE_SCOPE,
);
export const GET_SOCURE_CAPTURE_ERROR = createErrorType(
  GET_SOCURE_CAPTURE_SCOPE,
);
export const GET_SOCURE_CAPTURE_LOADING = createLoadingType(
  GET_SOCURE_CAPTURE_SCOPE,
);

// Socure Document Upload Endpoint
export const SOCURE_UPLOAD_DOCUMENT_SCOPE = 'SOCURE_UPLOAD_DOCUMENT';
export const SOCURE_UPLOAD_DOCUMENT = createSubmitType(
  SOCURE_UPLOAD_DOCUMENT_SCOPE,
);
export const SOCURE_UPLOAD_DOCUMENT_SUCCESS = createSuccessType(
  SOCURE_UPLOAD_DOCUMENT_SCOPE,
);
export const SOCURE_UPLOAD_DOCUMENT_ERROR = createErrorType(
  SOCURE_UPLOAD_DOCUMENT_SCOPE,
);
export const SOCURE_UPLOAD_DOCUMENT_LOADING = createLoadingType(
  SOCURE_UPLOAD_DOCUMENT_SCOPE,
);

// Manual Socure Verification Execution
export const SOCURE_VERIFICATION_SCOPE = 'SOCURE_VERIFICATION';
export const SOCURE_VERIFICATION = createUpdateType(SOCURE_VERIFICATION_SCOPE);
export const SOCURE_VERIFICATION_SUCCESS = createSuccessType(
  SOCURE_VERIFICATION_SCOPE,
);
export const SOCURE_VERIFICATION_ERROR = createErrorType(
  SOCURE_VERIFICATION_SCOPE,
);
export const SOCURE_VERIFICATION_LOADING = createLoadingType(
  SOCURE_VERIFICATION_SCOPE,
);

// Post Socure Event
export const SOCURE_EVENT_SCOPE = 'SOCURE_EVENT';
export const SOCURE_EVENT = createSubmitType(SOCURE_EVENT_SCOPE);
export const SOCURE_EVENT_SUCCESS = createSuccessType(SOCURE_EVENT_SCOPE);
export const SOCURE_EVENT_ERROR = createErrorType(SOCURE_EVENT_SCOPE);
export const SOCURE_EVENT_LOADING = createLoadingType(SOCURE_EVENT_SCOPE);
